import React from "react";

import TimeField from "react-simple-timefield";

import classnames from "classnames/bind";
import style from "../../styles/TimeInput.module.css";
import { If } from "./control-statements";

export class TimeInput extends React.Component {
  state = {};

  render() {
    const cx = classnames.bind(style);

    const {
      className,
      label: labelText,
      type,
      prefix,
      placeholder,
      valid = true,
      prefixWidth = 20,
      id,
      onChange,
      value,
      ...inputProps
    } = this.props;
    const { inputRef, style: inputStyle } = this.props;

    return (
      <div className={`${style.input} ${className}`}>
        <div
          className={cx({
            "label-float": true,
            placeholder: !!placeholder,
            invalid: !valid,
          })}
        >
          <If cond={prefix}>
            <div className={style.prefix} style={{ width: prefixWidth }}>
              {prefix}
            </div>
          </If>

          <TimeField
            inputRef={inputRef}
            value={value}
            input={
              <input
                type="tel"
                id={inputProps.id}
                value={inputProps.value || ""}
                placeholder={placeholder ? placeholder : labelText}
                style={{
                  paddingLeft: prefix ? prefixWidth + 20 : 15,
                  ...(inputStyle || {}),
                }}
                className={cx({
                  [`design-${inputProps.design}`]: !!inputProps.design,
                  center: !!inputProps.center,
                })}
              />
            }
            onChange={(e, value) => {
              onChange && onChange(value, e);
            }}
          />
          <If cond={!placeholder}>
            <label htmlFor={id}>{labelText}</label>
          </If>
        </div>
      </div>
    );
  }
}
